export const SET_LOGIN = "SET_LOGIN";
export const SET_MENTOR = "SET_MENTOR";
export const SET_TOKEN = "SET_TOKEN";
export const SET_COURSES_LIST = "SET_COURSES_LIST";
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_USER_ID = "SET_USER_ID";
export const SET_WEBINARS = "SET_WEBINARS";
